// home sec-2 card counter

  document.addEventListener("DOMContentLoaded", function () {
    const counters = document.querySelectorAll('.counter-number');

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const target = +el.getAttribute('data-target');
          let current = 0;
          const increment = target / 100;

          const updateCount = () => {
            current += increment;
            if (current < target) {
              el.innerText = Math.floor(current);
              requestAnimationFrame(updateCount);
            } else {
              el.innerText = target;
            }
          };

          updateCount();
          observer.unobserve(el); 
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(counter => {
      observer.observe(counter);
    });
  });
// sec-3 home-promo-section

  document.addEventListener('DOMContentLoaded', function () {
    const imageWrapper = document.querySelector('.karban-image-wrapper');

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.4
      }
    );

    if (imageWrapper) {
      observer.observe(imageWrapper);
    }
  });

// sec-4 home-media-tabbed-gallery


document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector('.media-tabbed-section');
  if (!section) return;

  const buttons = section.querySelectorAll('.tab-buttons button');
  const mediaWrapper = section.querySelector('.media-display');
  const prevBtn = section.querySelector('.prev-tab');
  const nextBtn = section.querySelector('.next-tab');
  const labelText = section.querySelector('.active-tab-label');

  let currentIndex = 0;

  function updateMedia(index) {
    const button = buttons[index];
    const type = button.dataset.type;
    const src = button.dataset.src;

    // Clear media
    mediaWrapper.innerHTML = '';
    let element;

    if (type === 'video') {
      element = document.createElement('video');
      element.src = src;
      element.controls = true;
      element.autoplay = true;
      element.muted = true;
      element.loop = true;
    } else {
      element = document.createElement('img');
      element.src = src;
    }

    element.classList.add('fade-up');
    mediaWrapper.appendChild(element);

    buttons.forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');

    // For mobile: update visible label
    if (labelText) {
      labelText.textContent = button.textContent;
    }

    currentIndex = index;
  }

  buttons.forEach((button, index) => {
    button.addEventListener('click', () => updateMedia(index));
  });

  if (prevBtn && nextBtn) {
    prevBtn.addEventListener('click', () => {
      const newIndex = (currentIndex - 1 + buttons.length) % buttons.length;
      updateMedia(newIndex);
    });

    nextBtn.addEventListener('click', () => {
      const newIndex = (currentIndex + 1) % buttons.length;
      updateMedia(newIndex);
    });
  }

  if (buttons.length > 0) {
    updateMedia(0);
  }
});

// sec-5 hero-futuristic

// sec-5 hero-futuristic


// sec-5 product range 

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".quick-view-btn").forEach((btn) => {
    btn.addEventListener("click", function () {
      document.querySelectorAll(".expanded-product").forEach((el) =>
        el.classList.remove("active")
      );
      const handle = btn.getAttribute("data-handle");
      const expanded = document.getElementById("expanded-" + handle);
      if (expanded) expanded.classList.add("active");
      expanded.scrollIntoView({ behavior: "smooth" });
    });
  });

  document.querySelectorAll(".expanded-close").forEach((btn) => {
    btn.addEventListener("click", function () {
      const handle = btn.getAttribute("data-close");
      const expanded = document.getElementById("expanded-" + handle);
      if (expanded) expanded.classList.remove("active");
    });
  });

// Get elements

const navActions = document.querySelector('.landing-nav__actions');
const benefitSection = document.getElementById('benefit');

// Only add the scroll listener if both elements exist
if (navActions && benefitSection) {
  window.addEventListener('scroll', () => {
    const benefitTop = benefitSection.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;

    if (benefitTop < windowHeight) {
      navActions.classList.add('show');   // fade in
    } else {
      navActions.classList.remove('show'); // fade out
    }
  });
}
});





document.addEventListener("DOMContentLoaded", function () {
  const footerColumns = document.querySelectorAll(".footer-columns .footer-column");

  footerColumns.forEach(column => {
    const toggleBtn = column.querySelector(".open-footer-nav");

    if (toggleBtn) {
      toggleBtn.addEventListener("click", function (e) {
        e.preventDefault();
        if (column.classList.contains("show-footer-nav")) {
          column.classList.remove("show-footer-nav");
        } else {
          footerColumns.forEach(c => c.classList.remove("show-footer-nav"));
          column.classList.add("show-footer-nav");
        }
      });
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const labels = document.querySelectorAll(".technical_details_label");

  labels.forEach(label => {
    label.addEventListener("click", function () {
      const parentRow = this.closest(".technical_details_row");

      if (parentRow.classList.contains("active")) {
        parentRow.classList.remove("active");
      } else {
        document.querySelectorAll(".technical_details_row").forEach(row => {
          row.classList.remove("active");
        });
        parentRow.classList.add("active");
      }
    });
  });
});